import { actionTypesEnum } from '../enum';

export const receptoresByEmisorReducer = (state = null, action) => {

    if(action.type === actionTypesEnum.getReceptoresByEmisor){
      return action.payload;
    }

     return state;
};

export const getReceptorHaciendaReducer = (state = null, action) => {

    if(action.type === actionTypesEnum.getReceptorHacienda){
      return action.payload;
    }

     return state;
};
 
